

export function SettingsWidget() {
    return (
        <div>
            <h2>Settings widget here!</h2>
        </div>
    );
}